export enum ModelAndSerialNumberFormField {
  ModelNumber = 'modelNumber',
  SerialNumber = 'serialNumber',
}
